import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';

import 'bootstrap/dist/css/bootstrap.min.css';

import Login from './pages/Login';
import Layout from './components/Layout';

// Página pública (sin auth) — la estrella
const ReportPublic = React.lazy(() => import('./pages/public/ReportPublic'));

// Panel admin (protegido)
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const Reports = React.lazy(() => import('./pages/Reports'));
const Incidents = React.lazy(() => import('./pages/Incidents'));
const Iperc = React.lazy(() => import('./pages/Iperc'));
const Actions = React.lazy(() => import('./pages/Actions'));
const Trainings = React.lazy(() => import('./pages/Trainings'));
const Epp = React.lazy(() => import('./pages/Epp'));
const Inspections = React.lazy(() => import('./pages/Inspections'));
const Emo = React.lazy(() => import('./pages/Emo'));
const Monitoring = React.lazy(() => import('./pages/Monitoring'));
const Audits = React.lazy(() => import('./pages/Audits'));
const Committee = React.lazy(() => import('./pages/Committee'));
const Documents = React.lazy(() => import('./pages/Documents'));
const AnnualPlan = React.lazy(() => import('./pages/AnnualPlan'));
const Alerts = React.lazy(() => import('./pages/Alerts'));
const Statistics = React.lazy(() => import('./pages/Statistics'));
const Users = React.lazy(() => import('./pages/Users'));
const QrPoster = React.lazy(() => import('./pages/QrPoster'));
const Settings = React.lazy(() => import('./pages/Settings'));

const Loading = () => <div style={{ padding: 40, textAlign: 'center', color: '#475569' }}>Cargando…</div>;
const S: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <React.Suspense fallback={<Loading />}>{children}</React.Suspense>
);

const App: React.FC = () => (
  <AuthProvider>
    <ToastProvider>
      <Router>
        <Routes>
          {/* Pública: Reporta seguro (QR) */}
          <Route path="/reportar/:tenant" element={<S><ReportPublic /></S>} />
          <Route path="/reportar" element={<Navigate to="/reportar/demo" replace />} />

          {/* Login */}
          <Route path="/login" element={<Login />} />

          {/* Panel protegido */}
          <Route path="/" element={<Layout />}>
            <Route index element={<S><Dashboard /></S>} />
            <Route path="reportes" element={<S><Reports /></S>} />
            <Route path="incidentes" element={<S><Incidents /></S>} />
            <Route path="iperc" element={<S><Iperc /></S>} />
            <Route path="acciones" element={<S><Actions /></S>} />
            <Route path="capacitaciones" element={<S><Trainings /></S>} />
            <Route path="epp" element={<S><Epp /></S>} />
            <Route path="inspecciones" element={<S><Inspections /></S>} />
            <Route path="emo" element={<S><Emo /></S>} />
            <Route path="monitoreo" element={<S><Monitoring /></S>} />
            <Route path="auditorias" element={<S><Audits /></S>} />
            <Route path="comite" element={<S><Committee /></S>} />
            <Route path="documentos" element={<S><Documents /></S>} />
            <Route path="plan-anual" element={<S><AnnualPlan /></S>} />
            <Route path="alertas" element={<S><Alerts /></S>} />
            <Route path="estadisticas" element={<S><Statistics /></S>} />
            <Route path="usuarios" element={<S><Users /></S>} />
            <Route path="qr" element={<S><QrPoster /></S>} />
            <Route path="configuracion" element={<S><Settings /></S>} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ToastProvider>
  </AuthProvider>
);

export default App;
